import { Component, ComponentInterface, h, Prop, VNode } from '@stencil/core';

import { UniHostTemplate } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

@Component({
  tag: 'uni-layout',
  styleUrl: '../styles/layout.css'
})
export class UniLayoutComponent implements ComponentInterface {

  @Prop({ reflect: true }) fluid: boolean = false;

  render(): VNode {
    const classes = { [`container${this.fluid ? '-fluid' : ''}`]: true };

    return UniHostTemplate({ classes }, <slot/>);
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
